import type {ReactElement} from 'react';
import React from 'react';
import {ControlledSlider} from '@Components/controlled-slider';
import {getCurrentPageDuration, getCurrentPageTime} from '@Components/poster-editor/poster-editor-reducer';
import {useAppSelector} from '@/hooks';

interface CustomDurationSliderProps {
  className?: string;
}

export function CustomDurationSlider({className = ''}: CustomDurationSliderProps): ReactElement<any> {
  const setCurrentTime = (newValue: number | number[]): void => {
    const time = Array.isArray(newValue) ? newValue[0] : newValue;
    const page = window.posterEditor?.whiteboard?.getCurrentPage();
    if (!page) {
      return;
    }
    void page.seek(time);
  };

  const currentPageTime = useAppSelector(getCurrentPageTime);

  const currentPageDuration = useAppSelector(getCurrentPageDuration);

  return <ControlledSlider className={className} value={currentPageTime} onSlide={setCurrentTime} max={currentPageDuration} step={0.1} handleStyle={{opacity: 0}} />;
}
